import React, { memo, useState } from 'react';
import {
  createUseStyles,
  useGetUserFindUser,
  usePutChatUpdateGroup,
} from 'core/src';
import { View } from 'react-native';
import {
  Avatar,
  Button,
  MyTextInput,
  ScrollingView,
  Spacing,
  Typography,
} from 'components/src';
import Ionicons from 'react-native-vector-icons/Ionicons';
import { useTranslation } from 'react-i18next';
import { useToast } from 'react-native-toast-notifications';
import {
  showBottomSheetUpdate,
  Store,
} from '../../organisms/myBottomsheet/store';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const IoniconsX = Ionicons as unknown as React.ComponentType<any>;

interface SelectedItem {
  id: any;
  type: any;
}

interface Props {
  groupMember?: any;
  conversationId?: any;
  refetchUser?: any;
}

const MemberList = memo<Props>(
  ({ groupMember, conversationId, refetchUser }) => {
    const { styles, colors } = useStyles();
    const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);
    const { data, refetch } = useGetUserFindUser({
      pageNumber: '1',
      pageSize: '900',
    });
    const { i18n } = useTranslation();
    const dispatch = Store.useDispatch();
    const [filterUser, setFilterUser] = useState<any>('');

    const toast = useToast();

    const { mutate } = usePutChatUpdateGroup({
      onSuccess: () => {
        dispatch(showBottomSheetUpdate(false));
        toast.show(i18n.t('added'), {
          type: 'success',
          placement: 'top',
          animationType: 'zoom-in',
        });
        refetch();
        refetchUser();
      },
    });

    const otherUser = data?.data?.converterToUserModel?.filter(
      (obj2: any) =>
        !groupMember?.some(
          (obj1: any) => obj1.user.user_name === obj2.userName,
        ),
    );

    const handleItemClick = (userName: any) => {
      const index = selectedItems.indexOf(userName);
      if (index !== -1) {
        setSelectedItems((prevList) =>
          prevList.filter((item) => item !== userName),
        );
      } else {
        setSelectedItems((prevList) => [...prevList, userName]);
      }
    };

    const handleAddMember = () => {
      mutate({
        // @ts-ignore
        requestBody: {
          conversationId: conversationId,
          ...(selectedItems?.length && { adds: selectedItems }),
        },
      });
    };

    return (
      <>
        <View style={{ height: 500, width: '100%' }}>
          <MyTextInput
            inputWidth={'100%'}
            change={(text) => {
              setFilterUser(text);
            }}
            classes={styles.input}
            inlineImageLeft={
              <MaterialIconsX
                name="search"
                size={25}
                color={colors.secondryColor}
              />
            }
            placeholder={i18n.t('enterName') + '...'}
          />
          <ScrollingView>
            <View style={styles.main}>
              {otherUser && otherUser.length > 0 ? (
                otherUser
                  .filter((item: any) => {
                    return item?.nameAndFamily?.includes(filterUser);
                  })
                  ?.map((item: any, index: number) => {
                    return (
                      <View
                        key={item.id}
                        style={[
                          styles.container,
                          {
                            opacity: selectedItems?.includes(item?.userName)
                              ? 0.3
                              : 1,
                          },
                        ]}
                      >
                        <Button
                          flexDirection={'column'}
                          onClick={() => handleItemClick(item?.userName)}
                        >
                          <Avatar
                            openImage={false}
                            radius={80}
                            size={70}
                            source={item?.avatar}
                          />
                          <Spacing vertical={5} />
                          <View
                            style={{
                              justifyContent: 'center',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <Typography
                              // classes={{ flexWrap: 'wrap', width: 70 }}
                              // text={item?.nameAndFamily}
                              text={
                                item?.nameAndFamily.length > 10
                                  ? item?.nameAndFamily
                                      .split(' ')
                                      .join('\n')
                                      ?.substring(0, 12) + '...'
                                  : item?.nameAndFamily
                              }
                              color={colors.primaryColor}
                              weight={'bold'}
                              textAlign={'center'}
                            />
                          </View>
                          <Spacing vertical={10} />
                        </Button>
                      </View>
                    );
                  })
              ) : (
                <Typography text="No data available" />
              )}
            </View>
          </ScrollingView>
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
            height: 100,
            bottom: -30,
            right: 20,
            position: 'absolute',
          }}
        >
          <Button classes={styles.button} onClick={handleAddMember}>
            <IoniconsX name={'add'} size={25} color={'#fff'} />
          </Button>
        </View>
      </>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: 100,
    marginBottom: 10,
  },
  input: {
    backgroundColor: colors.container,
  },
  text: {
    textAlign: 'center',
  },
  main: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
  },
  button: {
    backgroundColor: colors.color03,
    padding: 12,
    borderRadius: 40,
    width: 50,
    height: 50,
    textAlign: 'center',
    alignItems: 'center',
  },
}));

export { MemberList };
